// extracted by mini-css-extract-plugin
export default {"wrapper":"CRM_wrapper__GyGoA","stats":"CRM_stats__Z6YiD","text-yellow":"CRM_text-yellow__BnuK-"};